export const TOKEN_KEY = 'token';
export const TOKEN_TIME_KEY = 'token_time';
export const TOKEN_EXPIRATION_KEY = 'token_expiration';
export const USER_DATA_KEY = 'user_data';
export const PREFERENCE_SHOW_INACTIVE_USERS = 'preference_show_inactive_users';
